<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ACKNOWLEDGMENTS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width">First of all, I would like to thank <b><i>The Most High</i></b>, for blessing me with the skills to put my thoughts on paper; my life would be nothing without You. <b><i>Naleighna Kai</i></b>, thank you for welcoming me into your family. You go above and beyond for us, and I appreciate you more than you’ll ever know. <b>J.L Campbell</b>, thank you for helping me bring this story to life. Your guidance and patience means the world to me. <b><i>Tribe</i></b>, my life has not been the same because of you. Thank you for your love, kindness, and friendship. You guys rock! Thank you to my beta readers <b><i>Marie </i></b>and <b><i>Debra</i></b>. A special thank you also goes out to my cousin <b>Marisela </b>for providing me with the pictures of our beautiful island. <b>J.L. Woodson</b>, thank you so much for my awesome cover. And last but definitely not least, thank <b><i>you all </i></b>for picking up a copy of Queen of Curaçao.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Much love,</p>
<p class="subsq">Solsiré</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?412f93cc